export const SIGNUPDATA = {
  statusLabel: {
    ACTIVE: 'Active',
    PROCESSING: 'Processing',
    ADDED: 'Added'
  },
AccountsPage: {
  newSetupFanList: {
    name: 'Set up your accounts',
    rowDisable: false,
    rowDisableCondition: {},
    rowDisableConditionInverse: false,
    columnDefinitions: [
      {
        caption: 'Foundation account', field: 'fanId', type: 'TEXT', sortDirection: 'Asc',
        enableSorting: true, enableFilter: true, cssClass: '', priority: 1, customTemplate: ''
      }
    ]
  },
  revisedFanList: {
    name: 'Change enrollment settings',
    rowDisable: true,
    rowDisableCondition: {field: 'accountStatus', value: 'ACTIVE'},
    rowDisableConditionInverse: true,
    columnDefinitions: [
      {
        caption: 'Foundation account', field: 'fanId', type: 'CUSTOMTEMPLATE', sortDirection: 'Asc',
        enableSorting: true, enableFilter: true, cssClass: '', priority: 1, customTemplate: 'showFansProfile'
      },
      {
        caption: 'Status', field: 'accountSubStatus', type: 'TEXT', sortDirection: 'Asc',
        enableSorting: false, enableFilter: true, cssClass: '', priority: 2, customTemplate: ''
      }
    ]
  },
  awaitingSignupFanList: {
    name: 'Add accounts',
    rowDisable: true,
    rowDisableCondition: { field: 'addpEligibleStatus', value: undefined },
    rowDisableConditionInverse: false,
    columnDefinitions: [
      {
        caption: 'Foundation account', field: 'fanId', type: 'CUSTOMTEMPLATE', sortDirection: 'Asc',
        enableSorting: true, enableFilter: true, cssClass: '', priority: 1, customTemplate: 'fanEligiblityStatus'
      }
    ]
  }
},
ApplicationPage:
{
  columnDefinitions: [
    {
      caption: 'Application name', field: 'appName', type: 'CUSTOMTEMPLATE', sortDirection: 'Asc',
      enableSorting: true, enableFilter: true, cssClass: '', priority: 1, customTemplate: 'callBackAppNameCellTemplate'
    }
  ]
},
SettingsPage: {
  columnDefinitions: [
    {
      caption: '', field: 'selected', type: 'RADIO', sortDirection: 'Asc',
      enableSorting: false, enableFilter: false, cssClass: '', priority: 1, customTemplate: ''
    },
    {
      caption: 'Profile name', field: 'profileName', type: 'TEXT', sortDirection: 'Asc',
      enableSorting: true, enableFilter: false, cssClass: '', priority: 1, customTemplate: ''
    }
  ],
  securityPolicy: {
    SB: 'Standard',
    SE: 'Advanced'
  },
  passcodePolicy: {
    PN: 'None',
    PB: 'Standard',
    PS: 'Advanced'
  }
},
ReviewPage: {
  columnDefinitions: [
    {
      caption: 'Foundation account', field: 'fanId', type: 'TEXT', sortDirection: 'Asc',
      enableSorting: true, enableFilter: true, cssClass: '', priority: 1, customTemplate: ''
    }
  ]
}
};
